<template>
	<div class="container">
		<div class="header bar">
			<span class="btn-back" @click="closeWindow">
				월주차 신청
			</span>
		</div>

		<div class="contents">
			<div class="info-box">
				<p class="info-title">
					월주차 신청을 위해 필요 정보를 입력해주세요.<br />
					확인 후 차고지 전담팀에서 전화드리겠습니다.
				</p>
			</div>
			<div class="inp-box">
				<div class="line">
					<p class="part-title">이름</p>
					<p>
						<input type="text" v-model="name">
					</p>
					<p class="error-title" v-show="!isValidName">이름을 정확하게 입력해주세요.</p>
				</div>
				<div class="line">
					<p class="part-title">휴대전화</p>
					<p>
						<input type="tel" v-model="phone">
					</p>
					<p class="error-title" v-show="!isValidMobile">휴대전화 번호를 정확하게 입력해주세요.</p>
				</div>
				<div class="line">
					<p class="part-title">월주차 희망 주소</p>
					<div class="select-list clearfix">
						<div class="item f-left">
							<select v-model="city" @change="validateCity">
								<option value="">시/도 선택</option>
								<option v-for="v in cityList" :key="v.id" :value="v">{{ v.name }}</option>
							</select>
						</div>
						<div class="item f-left">
							<select v-model="county">
								<option value="">시/군/구 선택</option>
								<option v-for="v in countyList" :key="v.id" :value="v">{{ v.name }}</option>
							</select>
						</div>
					</div>
					<div class="select-list">
						<select v-model="parkinglot">
							<option value="">주차장 선택</option>
							<option v-for="v in selectParkinglot" :key="v.id" :value="v">{{ v.name }}</option>
						</select>
					</div>
					<p class="error-title">지역에 따라 월주차 기준이 다를 수 있습니다.</p>
				</div>
				<div class="line">
					<p class="part-title">차종 &middot; 차량 사이즈</p>
					<div class="select-list">
						<select v-model="carSize">
							<option v-for="v in carType" :key="v.sequence" :value="v">{{ v.carCombineName }}</option>
						</select>
					</div>
				</div>
				<div class="line">
					<p class="part-title">시작 희망일</p>
					<p>
						<date-picker :min="$moment(new Date()).format('YYYY/MM/DD')" :defaultDate="startDate" @selectedDate="selectDate" />
					</p>
				</div>
			</div>
			<div class="chk-box">
				<div class="line">
					<label for="privacy">
						<input type="checkbox" v-model="privacy" class="hidden square" id="privacy" />
						<span> [<button class="btn-link" @click="moveTerms">개인정보 수집, 이용(필수)</button>] 내용에 동의합니다. </span>
					</label>
				</div>
			</div>
			<div class="btn-box">
				<button class="btn big yellow radius" :disabled="!isPassValid" @click.prevent="doRegisterProcess">정보 입력 완료</button>
			</div>
		</div>
		<!-- <div class="dimmed" :class="{ active: isDimmed }">
			<img src="images/loaing.svg" />
		</div> -->
	</div>
</template>

<script type="text/javascript">
import axios from 'axios';

import DatePicker from '@/components/datepicker';
import baseUri from '@/assets/js/env';

export default {
	name: 'monthly-parking-apply',
	components: {
		DatePicker
	},
	filters: {},
	mixins: [],
	extends: {},
	props: {},
	data() {
		return {
			name: '',
			phone: '',
			startDate: this.$moment(new Date()).format('YYYY/MM/DD'),
			city: '',
			county: '',
			parkinglot: '',
			carSize: {},

			privacy: false,
			thirdParty: false,

			cityList: [],
			countyList: [],
			parkinglotList: [],
			parkinglotModel: [],
			carType: []
		};
	},
	computed: {
		isEmptyName() {
			return this.name !== '';
		},
		isEmptyPhone() {
			return this.phone !== '';
		},
		isValidName() {
			const nameRegex = /^[가-힣|a-z|A-Z|\s]{2,10}$/;
			return this.isEmptyName && nameRegex.test(this.name);
		},
		isValidMobile() {
			const mobileRegex = /^(01[0-9])-?([0-9]{3,4})-?([0-9]{4})$/;
			return this.isEmptyPhone && mobileRegex.test(this.phone);
		},
		isPassValid() {
			return this.isValidName && this.isValidMobile;
		},
		isCheckPrivacy() {
			return this.privacy;
		},
		isValidCity() {
			return this.city !== '';
		},
		isValidCounty() {
			return this.county !== '';
		},
		isValidParkinglot() {
			return this.parkinglot !== '';
		},

		selectCity() {
			return this.cityList.find(v => v.id === this.city);
		},
		selectCounty() {
			return this.countyList.find(v => v.id === this.county);
		},
		selectParkinglot() {
			return this.parkinglotModel.filter(v => v.cityId === this.county.id);
		}
	},
	watch: {
		county: {
			immediate: false,
			deep: true,
			handler() {
				this.parkinglotModel = this.parkinglotList.filter(rv => rv.cityId === this.county.id && rv.stateId === this.city.id)
				this.parkinglot = '';
			}
		}
	},
	methods: {
		getCity() {
			axios
				.get(`${baseUri}/common/address/state`, { params: { countryId: 'KOR' } })
				.then(resp => {
					const { resultData } = resp.data;
					const city = resultData.states;	
					const key = city.map(v => v.id);
					const result = [...new Set(this.parkinglotList.map(v => v.stateId).filter(v => v))].filter(v => key.filter(sv => v === sv));

					this.cityList = result.map(v => city.find(cv => v === cv.id));
					this.city = '';
				})
				.catch(err => console.trace(err.message));
		},
		getCounty() {
			axios
				.get(`${baseUri}/common/address/city`, { params: { stateId: this.city.id } })
				.then(resp => {
					const { resultData } = resp.data;
					const county = resultData.cities;
					const key = county.map(v => v.id);
					const result = [...new Set(this.parkinglotList.map(v => v.cityId).filter(v => v))].filter(v => key.filter(sv => v === sv));
					
					this.countyList = result.map(v => county.find(cv => v === cv.id)).filter(v => v);

					this.county = '';
					this.parkinglot = '';
				})
				.catch(error => console.trace(error.message));
		},
		getParkinglot() {
			axios
				.get(`${baseUri}/alliance/hyundaicommerce/garageMonthProductAddress`)
				.then(resp => {
					const { resultData } = resp.data;
					resultData.addressInfo.forEach(v => this.parkinglotModel[v.stateId] = [v]);

					this.parkinglotList = resultData.addressInfo;
					this.getCity();
				})
				.catch(err => console.trace(err.message));
		},
		getCarOption() {
			axios
				.get(`${baseUri}/common/car/classification`)
				.then(resp => {
					const { resultData } = resp.data;

					this.carType = resultData.carClassificationType;
					this.carSize = this.carType[0];
				})
				.catch(e => console.trace(e))
		},
		doRegister() {
			axios
				.post(`${baseUri}/alliance/hyundaicommerce/applyMonthProduct`, 
					{ 
						carClassificationTypeName: this.carSize.carCombineName,
						carClassificationTypeSequence: this.carSize.carTypeSequence,
						cityId: this.county.id,
						cityName: this.county.name,
						hopeDate: this.$moment(this.startDate).format('YYYY-MM-DD'),
						mobileNumber: this.phone.trim().replace(/-/g, ''),
						name: this.name.trim(),	
						parkinglotId: this.parkinglot.id,
						parklotName: this.parkinglot.name,
						stateId: this.city.id,
						stateName: this.city.name,
						countryId: 'KOR'
					}, {
						headers: {
							'Access-Control-Allow-Headers': '*'
						}
					}
				)
				.then(() => this.$router.replace({ name: 'complete', query: { t: 'monthly' } }))
				.catch(err => console.trace(err));
		},

		validateCity() {
			this.city ? this.getCounty() : (this.county = '', this.parkinglot = '', this.countyList = []);
		},
		validate() {
			if (!this.isValidCity) {
				alert('월주차 희망주소 "시/도"를 선택해주세요.');
				return;
			}
			
			if(!this.isValidCounty) {
				alert('월주차 희망주소 "시/군/구"를 선택해주세요.');
				return;
			}

			if(!this.isValidParkinglot) {
				alert('주차장을 선택해주세요.');
				return;
			}

			if (!this.isCheckPrivacy) {
				alert('개인정보 수집, 이용 동의를 체크해 주세요.');
				return;
			}

			return true;
		},
		doRegisterProcess() {
			this.isPassValid && this.validate() && this.doRegister();
		},

		moveTerms() {
			this.$store.commit('monthly/setData', this);
			this.$router.push({ name: 'monthly-parking-terms'});
		},
		rememberInfo() {
			const { monthly } = this.$store.state;

			Object.keys(monthly).forEach(v => monthly[v] && (this[v] = monthly[v]));
			monthly.city && setTimeout(() => (this.city = monthly.city), 333);
			monthly.carSize && setTimeout(() => (this.carSize = monthly.carSize), 333);
		},

		closeWindow() {
			window.close();
		},
		selectDate(v) {
			this.startDate = v;
		}
	},

	beforeCreate() {},
	created() {
		this.getParkinglot();
		this.getCarOption();
		this.rememberInfo();
	},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.select-list {
	&:nth-child(n + 2) {
		margin-top: 0.8em;
	}

	.item {
		width: 50%;

		&:nth-child(odd) {
			padding-right: 0.35em;
		}

		&:nth-child(even) {
			padding-left: 0.35em;
		}
	}

	select {
		width: 100%;
	}
}

.upload-list {
	.item {
		margin-bottom: 0.7em;
		font-size: 0.9em;
		color: #595957;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.btn-file-delete {
		display: inline-block;
		width: 20px;
		height: 16px;
		background: url(../assets/images/ico_close_mini.svg) no-repeat 0 50%;
		text-indent: -99999px;
		font-size: 0;
		vertical-align: middle;
	}
}

.upload-area {
	position: relative;

	label {
		display: inline-block;
		width: 100%;
		height: 50px;
		line-height: 50px;
		border-radius: 8px;
		background-color: #f0efea;
		text-align: center;
		font-size: 1.14em;
		font-weight: 500;
		color: #000;
	}

	input {
		&[type='file'] {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			overflow: hidden;
			clip: rect(0, 0, 0, 0);
			border: 0;
		}
	}
}

.dimmed {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.4);
	background-image: url(../assets/images/loading.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 128px 128px;
	display: none;

	&.active {
		display: block;
	}
}
</style>
